import React from "react";
import ImageComponent from "../ImageComponent";
import { Widget } from "../../interfaces/TournamentsConfig";

const BackToTopIcon: React.FC<Widget> = ({ items, onClick }) => {
  const { imageUrl = "" } = items[0];

  return (
    <div onClick={onClick} style={{ cursor: "pointer" }}>
      <ImageComponent src={imageUrl} alt={"back to top"} />
    </div>
  );
};

export default BackToTopIcon;
